import React from "react";

export function getAssetUrl(url: string): string {
  if (!url) return url;
  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("data:") ||
    url.startsWith("blob:")
  ) {
    return url;
  }
  const base = import.meta.env.BASE_URL || "/";
  const prefix = base.endsWith("/") ? base : `${base}/`;
  const cleanPath = url.startsWith("/") ? url.slice(1) : url;
  return `${prefix}${cleanPath}`;
}

export function getLinkUrl(href: string): string {
  if (!href) return href;
  if (
    href.startsWith("http://") ||
    href.startsWith("https://") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:") ||
    href.startsWith("#")
  ) {
    return href;
  }
  const base = (import.meta.env.BASE_URL || "/").replace(/\/$/, "");
  if (!base || base === "") {
    return href;
  }
  if (href === "/") {
    return `${base}/`;
  }
  if (href.startsWith(base)) {
    return href;
  }
  if (href.startsWith("/")) {
    return `${base}${href}`;
  }
  return href;
}

export function Image({
  src,
  alt = "",
  width,
  height,
  className,
  priority,
  unoptimized,
  draggable,
  style,
  children,
  dangerouslySetInnerHTML,
  ...rest
}: {
  src: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  priority?: boolean;
  unoptimized?: boolean;
  draggable?: boolean;
  style?: React.CSSProperties;
  children?: any;
  dangerouslySetInnerHTML?: any;
  [key: string]: any;
}) {
  const resolvedSrc = getAssetUrl(src);
  const imgProps: React.ImgHTMLAttributes<HTMLImageElement> = {
    src: resolvedSrc,
    alt: alt ?? "",
    className,
    draggable,
    style,
    loading: priority ? "eager" : "lazy",
  };

  if (width !== undefined) imgProps.width = width;
  if (height !== undefined) imgProps.height = height;

  for (const [key, val] of Object.entries(rest)) {
    if (
      key !== "children" &&
      key !== "dangerouslySetInnerHTML" &&
      key !== "unoptimized" &&
      key !== "priority"
    ) {
      (imgProps as any)[key] = val;
    }
  }

  return <img {...imgProps} />;
}

export default Image;

export function Link({
  href,
  children,
  className,
  style,
  onClick,
  ...rest
}: {
  href: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  [key: string]: any;
}) {
  const resolvedHref = getLinkUrl(href);
  const aProps: React.AnchorHTMLAttributes<HTMLAnchorElement> = {
    href: resolvedHref,
    className,
    style,
    onClick,
  };

  for (const [key, val] of Object.entries(rest)) {
    if (key !== "children" && key !== "dangerouslySetInnerHTML") {
      (aProps as any)[key] = val;
    }
  }

  return <a {...aProps}>{children}</a>;
}

